import React from 'react';
import './Error404.css'
import RippleGrid from '../Components/Layout/ErrBg';
import SectionLabel from '../Components/Common/SectionLabel';
import Btn from '../Components/Common/Btn';
import HeroText from '../Components/Common/HeroText';

const Error404 = () => {
    return ( <main className='Error404'>
            <div style={{position: 'absolute', height: '100vh', width: '100%' ,overflow: 'hidden'}}>
  <RippleGrid
    enableRainbow={false}
    gridColor="#009919"
    rippleIntensity={0.04}
    gridSize={10}
    vignetteStrength={0.2}
    gridThickness={10}
    mouseInteraction={true}
    mouseInteractionRadius={1}
    opacity={1}
  />
</div>

        <section className='ErrorContent'>

         <div className='ErrorText'>
         <SectionLabel SectionLabel="Error / 00"/>
         <p className='Num'><span className='green'>
                                        <HeroText
                                        text="404"
                                        flex
                                        alpha={false}
                                        stroke={false}
                                        width
                                        weight
                                        italic
                                        textColor="#35A44F"
                                        strokeColor="#5227FF"
                                        minFontSize={64}
                                    /></span> </p>
         <p className='ErrHead'>NOT FOUND</p>
         <p className='ErrSub'>It looks like the page you're looking for doesn't exist</p>
         </div>   
         <Btn BtnText="Go Home" BtnPath="/" className="FormBtn"/>

        </section>
    </main> );
}
 
export default Error404;